import React, { useState, useEffect } from "react";

// icons
import SongCard from "../../../components/reusable/SongCard";
import { IoChevronBack } from "react-icons/io5";

import MusicDetailLoading from "../../../components/skeletonLoading/detailLoading/MusicDetailLoading";
import { useFetchDetailDataQuery } from "../../../api/homepageApi";
import { useParams } from "react-router";
import { useNavbar } from "../../../context/NavBarContext";

import { NotFound } from "../../error/NotFound_404";
import { useMusic } from "../../../context/MusicContext";

const PlaylistDetail = () => {
  const musicContext = useMusic();
  const [isInitialMount, setIsInitialMount] = useState(true);
  const [options, setOptions] = useState({
    url: "",
    body: {},
  });

  const { data, error, isLoading, isFetching } = useFetchDetailDataQuery(
    options,
    {
      skip: isInitialMount,
    }
  );

  const Navbar = useNavbar();
  const { id } = useParams();

  useEffect(() => {
    if (data) {
      let copyData = data.result.filter((music) => music.can_play == 1);
      musicContext.setDummyPlayList(copyData);
    }
    const updateOptions = () => {
      setOptions(() => ({
        url: `/music/playlist/detail`,
        body: {
          playlist_id: id,
        },
      }));
    };

    updateOptions();
    setIsInitialMount(false);
    if (data) {
      Navbar.setLogoPlace(data.title);
      Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
    }
  }, [data]);

  if (isLoading) {
    return <MusicDetailLoading />;
  }

  if (error) {
    return <NotFound error={error} />;
  }

  return (
    <>
      {data?.result.map((item) => (
        <SongCard key={item.id} item={item} />
      ))}
    </>
  );
};

export default PlaylistDetail;
